// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__38vuG","validationTips":"StatementDescriptor_validationTips__KCq1-"};